import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["headline", "content", "cta", "trackEvent", "children"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { onTrackItemClickEvent, trackingPropType } from "../../util/tracking";
import { targetPropType } from "../../constants/target";
import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { Container, Headline, Content, Action } from "./rich-text-module.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RichTextModule = function RichTextModule(_ref) {
  var headline = _ref.headline,
    content = _ref.content,
    cta = _ref.cta,
    trackEvent = _ref.trackEvent,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dangerouslySetInnerHTML = useMemo(function () {
    return {
      __html: content
    };
  }, [content]);
  var text = get(cta, 'text');
  var url = get(cta, 'url');
  var target = get(cta, 'target');
  var onClick = useCallback(function () {
    onTrackItemClickEvent(cta, trackEvent);
  }, [cta, trackEvent]);
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, rest), {}, {
    children: [headline && /*#__PURE__*/_jsx(Headline, {
      "data-testid": "rich-text-module-headline",
      children: headline
    }), content ? /*#__PURE__*/_jsx(Content, {
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }) : /*#__PURE__*/_jsx(Content, {
      children: children
    }), cta && text && url && /*#__PURE__*/_jsx(Action, {
      "data-testid": "rich-text-module-cta",
      "data-gtm-event": "key_text_link",
      href: url,
      onClick: onClick,
      rel: "noopener noreferrer",
      target: target,
      children: text
    })]
  }));
};
RichTextModule.displayName = 'RichTextModule';
RichTextModule.propTypes = {
  headline: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  content: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: targetPropType,
    tracking: trackingPropType
  }),
  trackEvent: PropTypes.func
};
RichTextModule.defaultProps = {
  headline: '',
  cta: null,
  children: null,
  content: '',
  trackEvent: function trackEvent() {}
};
export default /*#__PURE__*/memo(RichTextModule);